export const Policies = [
    {
        title: `Information We Collect`,
        content: `When you contact us through our website, we may collect information such as your name, email address, phone number, and any details you provide in your message. We may also collect technical information such as your IP address and browser type to help improve our site.`,
    },
    {
        title: `How We Use Your Information`,
        content: `The information we collect is used to respond to inquiries, provide quotes or service details, and improve our website. We may also use it to communicate with you about our services.`,
    },
    {
        title: `Sharing of Information`,
        content: `We do not sell or rent your personal information to third parties. Information may only be shared with trusted service providers who assist us in operating our website or as required by law.`,
    },
    {
        title: `Data Security`,
        content: `We take reasonable measures to protect your information, but no system is completely secure. By using our site, you acknowledge that we cannot guarantee absolute security.`,
    },
    {
        title: `Your Rights`,
        content: `You may request access to, correction of, or deletion of your personal information by contacting us at fine.line.construction.jj@gmail.com`,
    },
    {
        title: `Changes to This Policy`,
        content: `We may update this Privacy Policy from time to time. Any changes will be posted here with the effective date updated accordingly.`,
    },
    {
        title: `Contact Us`,
        content: `If you have any questions about this Privacy Policy, please reach out to us at fine.line.construction.jj@gmail.com`,
    },
]
